import React from "react";
import { TIERS } from "@/lib/tiers";

const SIZE = { sm: "text-[10px] px-2 py-0.5", md: "text-xs px-2.5 py-1" };

const TierBadge = ({ tier = "none", size = "md", showLabel = true, testId }) => {
  const cfg = TIERS[tier] || TIERS.none;
  const Icon = cfg.Icon;
  if (tier === "none" && !showLabel) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm font-semibold uppercase tracking-widest ${SIZE[size]}`}
      style={{ backgroundColor: cfg.bg, color: cfg.color }}
      data-testid={testId || `tier-badge-${tier}`}
      title={`${cfg.label} — ${cfg.tagline}`}
    >
      <Icon size={size === "sm" ? 10 : 12} weight="fill" />
      {showLabel && cfg.label}
    </span>
  );
};

export default TierBadge;
